import styled from 'styled-components';
import { getMargins } from '@oneaudi/unified-web-common';
export const StyledDivider = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  width: ${(props) => (props.$orientation === 'vertical' ? '1px' : '100%')};
  height: ${(props) => (props.$orientation === 'vertical' ? '100%' : '1px')};
  background-color: ${(props) => props.theme.sys.color.surface.neutral[500]};
`;
//# sourceMappingURL=index.styles.js.map